import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

export const AssetDetailsContext = createContext({ })

export const useAssetDetails = () => {
  return useContext(AssetDetailsContext)
}

export const useSectionEditing = (sectionName) => {
  const { editing, section } = useAssetDetails()
  return useMemo(() => {
    return editing && section === sectionName
  }, [editing, section, sectionName])
}

const useProviderValue = ({ asset, isFetching }) => {
  const [formState, setFormState] = useState({
    editing: false,
    section: null
  })

  const editSection = useCallback(({
    section
  }) => {
    setFormState((prevState) => ({
      ...prevState,
      editing: !prevState.editing,
      section: !prevState.editing ? section : null
    }))
  }, [setFormState])

  const cancelEdit = useCallback(() => {
    setFormState((prevState) => ({
      ...prevState,
      editing: false,
      section: null
    }))
  }, [setFormState])

  return useMemo(() => ({
    asset,
    editSection,
    cancelEdit,
    isFetching,
    ...formState
  }), [asset, editSection, cancelEdit, formState, isFetching])
}

export const AssetProvider = ({ asset, isFetching, children }) => {
  const value = useProviderValue({
    asset,
    isFetching
  })

  return (
    <AssetDetailsContext.Provider value={value}>
      {children}
    </AssetDetailsContext.Provider>
  )
}

AssetProvider.propTypes = {
  asset: PropTypes.object,
  children: PropTypes.node,
  isFetching: PropTypes.bool
}

AssetProvider.defaultProps = {
}
